
import { useEffect, useState } from "react";
import axios from "axios";
import "./NotesPage.css";

function NotesPage() {
  const [notes, setNotes] = useState([]);
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [yearFilter, setYearFilter] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("");
  const [courseFilter, setCourseFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true); // ✅ NEW state

  useEffect(() => {
    axios
      .get("https://lepic.onrender.com/api/notes")
      .then((res) => {
        setNotes(res.data);
        setFilteredNotes(res.data);
        setLoading(false); // ✅ Stop loading after data fetched
      })
      .catch((err) => {
        console.log(err);
        setLoading(false); // ✅ Stop loading even if error occurs
      });
  }, []);

  useEffect(() => {
    let filtered = notes;

    if (yearFilter) {
      filtered = filtered.filter(note => note.year === yearFilter);
    }
    if (subjectFilter) {
      filtered = filtered.filter(note => note.subjectCode.toLowerCase().includes(subjectFilter.toLowerCase()));
    }
    if (courseFilter) {
      filtered = filtered.filter(note => note.course.toLowerCase().includes(courseFilter.toLowerCase()));
    }
    if (searchTerm) {
      filtered = filtered.filter(note =>
        note.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        note.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredNotes(filtered);
  }, [yearFilter, subjectFilter, courseFilter, searchTerm, notes]);

  const handleBuy = async (id) => {
    try {
      const res = await axios.get(`https://lepic.onrender.com/api/notes/buy/${id}`);
      const { noteName, price, year, subjectCode, course, UploadDate } = res.data;

      const googleFormUrl = `https://docs.google.com/forms/d/e/1FAIpQLSeOyHXy_Ij7Q470f29Bxn700mok0bdKoE89iXpmRgM-4YZ_Aw/viewform?usp=pp_url&entry.483312522=${encodeURIComponent(noteName)}&entry.1252032681=${encodeURIComponent(price)}&entry.922820561=${encodeURIComponent(year)}&entry.147560032=${encodeURIComponent(subjectCode)}&entry.954296709=${encodeURIComponent(course)}&entry.1085324660=${encodeURIComponent(UploadDate)}`;

      window.location.href = googleFormUrl;
    } catch (error) {
      console.error("Error retrieving note details:", error);
      alert("Failed to fetch note details. Please try again.");
    }
  };

  return (
    <div className="notes-page">
      <h1>All Notes</h1>

      <div className="notes-container">
        {/* Sidebar Filter */}
        <div className="sidebar">
          <input
            type="text"
            placeholder="Search notes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <select value={yearFilter} onChange={(e) => setYearFilter(e.target.value)}>
            <option value="">Filter by Year</option>
            <option value="1st Year">1st Year</option>
            <option value="2nd Year">2nd Year</option>
            <option value="3rd Year">3rd Year</option>
            <option value="4th Year">4th Year</option>
          </select>

          <input
            type="text"
            placeholder="Filter by Subject Code"
            value={subjectFilter}
            onChange={(e) => setSubjectFilter(e.target.value)}
          />

          <input
            type="text"
            placeholder="Filter by Course"
            value={courseFilter}
            onChange={(e) => setCourseFilter(e.target.value)}
          />
        </div>

        {/* Notes Grid */}
        <div className="notes-grid">
          {loading ? (
            <p>Loading notes...just wait for few seconds😊</p>
          ) : filteredNotes.length > 0 ? (
            filteredNotes.map(note => (
              <div key={note._id} className="note-card">
                <h2>{note.title}</h2>

                {note.notesImage && (
                  <img
                    src={note.notesImage}
                    alt={note.title}
                    className="note-image"
                  />
                )}
                <p className="note-description">{note.description}</p>
                <p className="note-subject"><strong>Subject Code:</strong> {note.subjectCode}</p>
                <p className="note-year"><strong>Year:</strong> {note.year}</p>
                <p className="note-course"><strong>Course:</strong> {note.course}</p>
                <p className="note-date"><strong>Upload Date:</strong> {note.UploadDate}</p>
                <p className="note-price"><strong>Price:</strong> ₹{note.price}</p>

                <button className="buy-button" onClick={() => handleBuy(note._id)}>
                  Buy Now
                </button>
              </div>
            ))
          ) : (
            <p>No notes found matching the criteria.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default NotesPage;
